"use client";

import useCart from "@/stores/cart";
import { useCallback, useEffect, useState } from "react";
import routes from "@/app.route";
import { Button, Card, CircularProgress, useMediaQuery } from "@mui/material";
import Image from "next/image";
import Loading from "./_loading";
import CartMobile from "./_cart-mobile";
import Cart from "./_cart";
import LoadingMobile from "./_loading-mobile";
import SparkleEffect from "@/components/sparkle-effect";

export default function Page() {
  const { dataLoading, items, fetchProducts } = useCart();
  const [mounted, setMounted] = useState(false);
  const matches = useMediaQuery("(min-width:1024px)");
  const getProducts = useCallback(fetchProducts, []);

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="min-h-[calc(100vh-65px)] flex items-center justify-center">
        <CircularProgress size="3rem" />
      </div>
    );
  }

  if (dataLoading) {
    return matches ? <Loading /> : <LoadingMobile />;
  }

  return (
    <>
      <main>
        {items.length == 0 ? (
          <div className="max-w-7xl mx-auto px-4 py-4 md:py-8">
            <Card>
              <div className="py-12">
                <figure className="mb-8">
                  <Image
                    src="/images/no-cart-items.webp"
                    alt="Your cart is empty!"
                    width={740}
                    height={540}
                    className="mx-auto max-w-56"
                    priority
                  />
                </figure>
                <h1 className="md:text-4xl text-2xl text-center">
                  Your shopping cart is empty.
                </h1>
                <div className="mx-auto w-full max-w-52 mt-6">
                  <SparkleEffect>
                    <Button href={routes.home.url} variant="outlined" fullWidth>
                      Continue shopping
                    </Button>
                  </SparkleEffect>
                </div>
              </div>
            </Card>
          </div>
        ) : (
          <>{matches ? <Cart /> : <CartMobile />}</>
        )}
      </main>
    </>
  );
}
